.container {
  margin: 32px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.icon {
  width: min(80vw, 720px);
  height: auto;
}

.heading {
  margin-bottom: 64px;
}
